import type { GamesRecommendationsTransformed, GetGamesRecommendationsResponse } from 'src/types/recommendations';

const arrayToObj = (
  arr:
    | GetGamesRecommendationsResponse['model']['additionalInputParams']
    | GetGamesRecommendationsResponse['model']['additionalOutputParams'],
) => {
  const obj: Record<string, string> = {};

  arr.forEach(({ name, value }) => {
    obj[name] = value;
  });

  return obj;
};

export const transformGetGamesRecommendationsResponse: (
  res: GetGamesRecommendationsResponse,
) => GamesRecommendationsTransformed = (res) => ({
  ...res,
  model: {
    ...res.model,
    additionalInputParams: arrayToObj(res.model.additionalInputParams),
    additionalOutputParams: arrayToObj(res.model.additionalOutputParams),
  },
});
